namespace Matrix.Data {
    export interface AccountModelTargetImportRequest extends Serenity.ServiceRequest {
        ModelCode?: string;
        FileName?: string;
    }
}
